import { Injectable, Injector, Type } from '@angular/core';
import { DocumentEditItemBase } from '@fi-app/document/edit-item/edit-item-base';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { isNullOrUndefined } from '@fi-shared/utils/is-null-or-undefined';

@Injectable()
export class DocumentPanelRootService {
    public panelComponent: Type<any>;
    public panelInjector: Injector;
    public editComponent: DocumentEditItemBase;

    setPanel(panelComponent: Type<any>, panelInjector: Injector, editComponent: DocumentEditItemBase) {
        this.panelComponent = panelComponent;
        this.panelInjector = panelInjector;
        this.editComponent = editComponent;
    }
}
